import { atom } from "recoil"
import { GroupColumn, GroupColumnSelectedType } from "common/types/routesType"

export const impersonationEmailAtom = atom<string | undefined>({
    key: "impersonationEmail",
    default: undefined,
})

export const searchTypeAtom = atom<string | undefined>({
    key: "searchType",
    default: undefined,
})

export const columnGroupSelectedAtom = atom<GroupColumnSelectedType>({
    key: "columnGroupSelected",
    default: GroupColumn.unitDetails,
})

